import { render } from "./DocumentCookie.vue?vue&type=template&id=cb618402"
import script from "./DocumentCookie.vue?vue&type=script&lang=js"
export * from "./DocumentCookie.vue?vue&type=script&lang=js"

import "./DocumentCookie.vue?vue&type=style&index=0&id=cb618402&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__